import { Helmet } from 'react-helmet-async';
import { PAGE_META, SITE_ORIGIN, type PageMeta } from '../lib/seo';

export function PageSeo({
  meta,
  title,
  description,
  path,
  ogType,
}: {
  meta?: PageMeta;
  title?: string;
  description?: string;
  path?: string;
  ogType?: 'website' | 'article';
}) {
  const resolvedTitle = title ?? meta?.title ?? PAGE_META.home.title;
  const resolvedDescription = description ?? meta?.description ?? PAGE_META.home.description;
  const resolvedPath = path ?? meta?.path ?? '/';
  const canonical = `${SITE_ORIGIN}${resolvedPath}`;

  return (
    <Helmet>
      <html lang="en" />
      <title>{resolvedTitle}</title>
      <meta name="description" content={resolvedDescription} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={resolvedTitle} />
      <meta property="og:description" content={resolvedDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={ogType ?? 'website'} />
    </Helmet>
  );
}
